export enum CampaignTypeEnum {
  UNIQUE = "unique",
  MASTER = "master",
}

export enum MasterCampaignTypeEnum {
  SINGLE = "single",
  MULTIPLE = "multiple",
}
